const pillars = [
  { icon: "ri-flag-2-fill", title: "真实有料", desc: "坚守内容真实性底线，线索需经核实与审核，让每一条爆料都站得住脚。" },
  { icon: "ri-group-fill", title: "理性讨论", desc: "倡导客观友善的吃瓜氛围，让观点交锋而非情绪对喷成为主流。" },
  { icon: "ri-shield-check-line", title: "隐私保护", desc: "严格脱敏与举报机制，尊重每一位投稿人，守护敏感信息不被滥用。" },
];

const stats = [
  { num: "380万+", label: "注册吃瓜群众" },
  { num: "12万+", label: "累计收录爆料" },
  { num: "24h", label: "投稿极速审核" },
  { num: "98%", label: "用户满意口碑" },
];

export default function AboutStrip() {
  return (
    <section id="about" className="bg-[#201d1a] py-16 md:py-20 text-[#fbf7ef]">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid lg:grid-cols-2 gap-10 items-center">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-emerald-600/20 text-emerald-300 text-sm font-medium px-4 py-1.5">
              <i className="ri-heart-3-fill w-4 h-4 flex items-center justify-center"></i> 关于爆瓜网
            </span>
            <h2 className="mt-5 font-serif-cn text-2xl md:text-4xl font-black leading-snug">
              让真实的声音，
              <br />
              在这里被<b className="text-[#ff6b5e]">听见与共鸣</b>
            </h2>
            <p className="mt-5 text-[#fbf7ef]/70 leading-relaxed">
              爆瓜网相信，每一条看似平凡的线索背后，都可能藏着一个值得被看见的故事。我们连接投稿人与围观群众，用真实、理性、有趣的讨论，把热闹留给话题，把尊重留给每一个认真分享的人。
            </p>
            <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-4">
              {stats.map((s) => (
                <div key={s.label} className="rounded-2xl bg-white/5 p-4 text-center">
                  <p className="font-display text-2xl text-emerald-300">{s.num}</p>
                  <p className="mt-1 text-xs text-[#fbf7ef]/60">{s.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="space-y-4">
            {pillars.map((p) => (
              <div key={p.title} className="flex gap-4 rounded-2xl bg-white/5 border border-white/10 p-5">
                <span className="grid w-11 h-11 rounded-xl bg-emerald-600/25 text-emerald-300 place-items-center shrink-0">
                  <i className={`${p.icon} w-6 h-6 flex items-center justify-center`}></i>
                </span>
                <div>
                  <h3 className="font-bold text-lg">{p.title}</h3>
                  <p className="mt-1 text-sm text-[#fbf7ef]/65 leading-relaxed">{p.desc}</p>
                </div>
              </div>
            ))}
            <blockquote className="rounded-2xl border-l-4 border-[#ff6b5e] bg-white/5 p-5">
              <p className="text-[#fbf7ef]/85 italic leading-relaxed">
                "在这里吃到的瓜既有热度也有温度，评论区从不让人失望。把一个线索交给爆瓜网，是能放心的事情。"
              </p>
              <footer className="mt-2 text-sm text-emerald-300">—— 资深吃瓜人 · 一颗柠檬不加糖</footer>
            </blockquote>
          </div>
        </div>
      </div>
    </section>
  );
}